import * as SplashScreen from 'expo-splash-screen'
import { useState, useEffect } from 'react'
import {
  useFonts,
  NunitoSans_400Regular,
  NunitoSans_400Regular_Italic,
  NunitoSans_700Bold,
} from '@expo-google-fonts/nunito-sans'
import {
  Montserrat_400Regular,
  Montserrat_700Bold,
} from '@expo-google-fonts/montserrat'

// import { configureStore } from '../store/configureStore'
import ActionCreators from '../store/actions'

const hansGretelIconFont = require('../../assets/fonts/hansgretelicons/hansgretelicons.ttf')

const useCachedResources = (store: any) => {
  const { dispatch } = store
  const [isLoadingComplete, setIsLoadingComplete] = useState(false)

  const [fontsLoaded] = useFonts({
    NunitoSans_400Regular,
    NunitoSans_400Regular_Italic,
    NunitoSans_700Bold,
    Montserrat_400Regular,
    Montserrat_700Bold,
    hansgretelicons: hansGretelIconFont,
  })

  /**
   * Method that serves to load resources and make API calls
   */
  const prepareResources = async () => {
    try {
      await dispatch(ActionCreators.loadDataFromStorage())
      await dispatch(ActionCreators.initApp())
      await dispatch(ActionCreators.loadProfileData())
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn(e);
    } finally {
      setIsLoadingComplete(true)
      SplashScreen.hideAsync()
    }

  };

  // Load any resources or data that we need prior to rendering the app
  useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        await SplashScreen.preventAutoHideAsync();
      } catch (e) {
        console.warn(e);
      }
      prepareResources()
    }

    loadResourcesAndDataAsync()
  }, [])

  return fontsLoaded && isLoadingComplete
}

export default useCachedResources
